import 'core-js';

// forEach for NodeList, not (yet) included in core-js as of 6/4/2018
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

import 'babel-polyfill';
import 'url-polyfill';
import 'fetch-ie8';

import * as helpers from './helpers.js';
import * as state from './state.js';
import * as shopify from './shopify.js';
import * as shopifyI18n from './i18n-shopify.js';
import * as shopifyCartSync from './shopify-cart-sync.js';
import * as downloads from './downloads.js';
import * as scripts from './scripts.js';
import * as i18n from './i18n.js';
import * as calculator from './calculator.js';
import * as productsMenu from './products-menu.js';
import * as country from './country.js';
import * as headerFooter from './header-footer.js';
import * as tax from './tax.js';
import {processingDialog} from './widgets.js';

(async () => {
  scripts.init();

  await Promise.all([
    helpers.waitForPageLoad(),
    i18n.init(),
    state.init(),
  ]);

  await Promise.all([
    shopify.init(),
    shopifyI18n.init(),
  ]);

  let cartSync = shopifyCartSync.init();  // async

  helpers.loadDeferredResources();
  helpers.lazyLoadImages();
  productsMenu.init();
  country.init();
  tax.init();
  headerFooter.init();
  downloads.init();
  calculator.init();

  await cartSync;
  helpers.finished();
})();
